import {
  LABORDENDIGITAL_GETPDF_ERROR,
  LABORDENDIGITAL_GETPDF_LOADING,
  LABORDENDIGITAL_GETPDF_RESET,
  LABORDENDIGITAL_GETPDF_SUCCESS,
} from "_+_Portal/context/ActionTypes";
import axiosLogin from "global/helpers/axiosLogin";

export const wsGetPDFOrdenDigital = (idOrdenDigital, nextStep) => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_GETPDF_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .get(`lis/laboratorio/ordendigital/GetPDF/${idOrdenDigital}/pdf`, {
          responseType: "blob",
        })
      .then((res) => {
        const blob = res.data;
        dispatch({
          type: LABORDENDIGITAL_GETPDF_SUCCESS,
          payload: res.data,
        });
        if (nextStep) nextStep(true, { blob });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: LABORDENDIGITAL_GETPDF_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, err?.response?.data);
      });
  });
};

export const resetPDFOrdenDigital = () => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_GETPDF_RESET,
  });
};
